/* eslint-disable @typescript-eslint/no-explicit-any */
export function addMetrik(arrId: (number | string)[]): void {
  (function (
    m: any,
    e: Document,
    t: string,
    r: string,
    i: string,
    k?: any,
    a?: any
  ): void {
    m[i] =
      m[i] ||
      function (...args: any[]): void {
        (m[i].a = m[i].a || []).push(args);
      };
    m[i].l = Date.now();

    for (let j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) {
        return;
      }
    }

    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = true;
    k.src = r;
    a.parentNode?.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  arrId.forEach((id, num) => {
    window.ym?.(Number(id), "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: num === 0 && id !== "106353501"
    });

    window.ym?.(Number(id), "hit");
  });
}
export function getYMCID(): string | false {
  var match = document.cookie.match("(?:^|;)\\s*_ym_uid=([^;]*)");
  if (!match) {
    return false;
  }

  let matchInt = match.map((a) => {
    return a.replace(/\D/g, "");
  });
  return "_ym_uid=" + Array.from(new Set(matchInt)).join(" ");
}
